<template>
  <div v-if="isRequirementsExtracting" class="requirements-extraction-progress">
    <div v-for="(step, index) in displaySteps" :key="step.key" class="requirements-extraction-progress__step">
      <span class="icon">
        <template v-if="index < currentStepIndex">
          <BaseIcon name="check-circle" class="requirements-extraction-progress__step-completed-icon" />
        </template>
        <template v-else-if="index === currentStepIndex">
          <BaseCircularLoadingBar :size="16" :width="2" />
        </template>
        <template v-else>
          <span class="requirements-extraction-progress__step-not-started-icon"></span>
        </template>
      </span>
      <span>{{ step.text }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseCircularLoadingBar from '@/components/base/BaseCircularLoadingBar.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { DISPLAY_STEPS, getDisplayStepIndex } from '@/models/extraction-steps';

export default {
  name: 'RequirementsExtractionProgress',
  components: { BaseCircularLoadingBar, BaseIcon },
  computed: {
    ...mapGetters('requirementsExtraction', ['isRequirementsExtracting', 'requirementsCurrentStep']),
    displaySteps() {
      return DISPLAY_STEPS.map(({ displayKey }) => ({
        key: displayKey,
        text: this.$t(`opportunity-tasks.generation-steps.${displayKey}`),
      }));
    },
    currentStepIndex() {
      return getDisplayStepIndex(this.requirementsCurrentStep);
    },
  },
};
</script>

<style scoped lang="scss">
.requirements-extraction-progress {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px;

  &__step {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: $font-size-small;
    color: $color-neutral;

    &-not-started-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid $color-neutral;
    }

    &-completed-icon {
      width: 16px;
      color: $color-green;
    }
  }
}
</style>
